import React, { useEffect } from 'react';
import Glide from '@glidejs/glide';
import ContentModelHandler from '../../utils/ContentModelHandler';

interface CarouselInterface {
  data: Array<any>;
  id: string;
  settings: {
    type: boolean;
    animationDuration: number;
    autoplay: number;
    itemsPerViewDesktop: number;
    itemsPerViewTablet: number;
    itemsPerViewMobile: number;
    startAt: number;
    showNavigationArrows: boolean;
    fadeEdges: string;
    extraClasses: string;
  };
}

function Carousel(props: CarouselInterface) {
  const carouselItems = props.data;

  const {
    type,
    animationDuration,
    autoplay,
    itemsPerViewDesktop,
    itemsPerViewTablet,
    itemsPerViewMobile,
    startAt,
    showNavigationArrows,
    fadeEdges,
    extraClasses,
  } = props.settings;

  useEffect(() => {
    const slider = new Glide(`.glide-${props.id}`, {
      type: type ? 'carousel' : 'slider',
      focusAt: 0,
      startAt: startAt,
      autoplay: autoplay,
      gap: 16,
      animationDuration: animationDuration,
      perView: itemsPerViewDesktop,
      breakpoints: {
        810: {
          perView: itemsPerViewTablet || 2,
        },
        640: {
          perView: itemsPerViewMobile || 1,
        },
      },
      peek: {
        before: 0,
        after: 0,
      },
      /* @ts-ignore */
      classes: {
        nav: {
          active: '[&>*]:bg-primary-300',
        },
      },
    }).mount();

    return () => {
      slider.destroy();
    };
  }, []);

  const fadeHandler = (fadeType: string) => {
    switch (fadeType) {
      case 'fade to neutral color':
        return 'glide--faded';
      case 'fade to white':
        return 'glide--faded glide--faded-white';
      default:
        return '';
    }
  };
  return (
    <div className={`glide glide-${props.id} ${fadeHandler(fadeEdges)} ${extraClasses || ' '}`}>
      <div className='glide__track' data-glide-el='track'>
        <ul className='glide__slides '>
          {carouselItems &&
            carouselItems.map((item) => {
              return (
                <li className='glide__slide' key={item.id}>
                  {ContentModelHandler([item].flat())}
                </li>
              );
            })}
        </ul>
      </div>
      {showNavigationArrows && (
        <div className='glide__controls' data-glide-el='controls'>
          <button className='glide__controls-arrows' data-glide-dir='<' aria-label='prev slide'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              fill='none'
              viewBox='0 0 24 24'
              strokeWidth='1.5'
              stroke='currentColor'
              className='w-5 h-5'
            >
              <title>prev slide</title>
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                d='M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18'
              />
            </svg>
          </button>
          <button className='glide__controls-arrows' data-glide-dir='>' aria-label='next slide'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              fill='none'
              viewBox='0 0 24 24'
              strokeWidth='1.5'
              stroke='currentColor'
              className='w-5 h-5'
            >
              <title>next slide</title>
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                d='M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3'
              />
            </svg>
          </button>
        </div>
      )}
    </div>
  );
}

export default Carousel;
